const groupBy = (arr, key) => {
  if (!Array.isArray(arr)) {
    throw new Error('first argument needs to be an array');
  }
  const lookup = {};
  return arr.reduce((group, current) => {
    if (lookup[current[key]]) {
      lookup[current[key]].push(current);
    } else {
      lookup[current[key]] = [current];
    }
    return Object.values(lookup);
  }, []);
};

export default groupBy;
